<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0041_master_maker_detail</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-slot title="棚卸(棚卸報告)" >
          </title-and-slot>
      <div class="row" style="margin-bottom: 10px">
        <div class="col-xs-12">
          <div
            style="
              width: 180px;
              float: right;
              font-size: 12px;
              text-align: right;
            "
          >
            更新日時：{{ update_Date }}
          </div>
          <div
            style="
              width: 180px;
              float: right;
              font-size: 12px;
              text-align: right;
            "
          >

            報告日：{{ create_Date }}
          </div>
        </div>
      </div>
      <div class="row" style="margin-bottom: 10px">
        状態：
        <input
          :disabled="true"
          style="
            border: solid #337ab7 1px;
            width: 60px;
            padding-left: 4px;
            margin: 2px;
            border-radius: 5px;
            background-color: #e2ecf5;
            font-size: 12px;
          "
          :value="status_value"
        />
        提出:
        <input
          :readonly=true
          :value="new_or_resubmit_value"
          style="
            border: solid #337ab7 1px;
            width: 60px;
            padding-left: 4px;
            margin: 2px;
            border-radius: 5px;
            background-color: #e2ecf5;
            font-size: 12px;
          "
        >
        <div style="float: right;">
        報告者:
        <input
          :readonly=true
          :value="created_by_value"
          style="
            border: solid #337ab7 1px;
            width: 200px;
            padding-left: 4px;
            margin: 2px;
            border-radius: 0px;
            background-color: #e2ecf5;
            font-size: 12px;
          "
        >
        </div>
       </div>
          <div class="row" style="margin-top:15px;margin-bottom:20px;;margin-right:20px">
          <div class="row" style="">
            <div class="col-xs-5" style="">
          <div class="row"  style="margin-bottom: 5px;"> 
            <label class="col-xs-3 control-label esma_form_label">棚卸報告年度区分</label>
              <select 
              class="select-box"
              :value = "selvalues[Searchmap('reporting_period')]"
              :disabled = "selectdisable['reporting_period']" 
              :readonly = "selectreadonly['reporting_period']" 
              @change="SelectSearch({id:'reporting_period',value:$event.target.value})">
                <option></option>
                <option v-for="r in reportingPeriodList" :key="r.val" :value="r.val">{{r.val}}</option>
              </select>
            </div>

            <div class="row"  style="margin-bottom: 5px;"> 
              <label class="col-xs-3 control-label esma_form_label">会社</label>
              <select 
              class="select-box"
              :value = "selvalues[Searchmap('company')]"
              :disabled = "selectdisable['company']" 
              :readonly = "selectreadonly['company']" 
              @change="SelectSearch({id:'company',value:$event.target.value})">
                <option v-if="EditableUser == true"></option>
                <option v-for="r in companylist" :key="r.val" :value="r.val">{{r.val}}</option>
              </select>
            </div>

            <div class="row"  style="margin-bottom: 5px;"> 
              <label class="col-xs-3 control-label esma_form_label" style ="margin-right:10px">部署</label>
              <select 
              class="select-box"
                :value = "selvalues[Searchmap('department')]"
                :disabled = "selectdisable['department']"
                :readonly = "selectreadonly['department']" 
                @change="SelectSearch({id:'department',value:$event.target.value})">
                <option v-if="EditableUser == true"></option>
                <option v-for="r in departmentlist" :key="r.val" :value="r.val">{{r.val}}</option>
              </select>
            </div>

            <div class="row"  style="margin-bottom: 5px;"> 
              <label class="col-xs-3 control-label esma_form_label">チーム</label>
              <select 
                 class="select-box"
                :value = "selvalues[Searchmap('team')]"
                :disabled = "selectdisable['team'] || teammode == false" 
                :readonly = "selectreadonly['team']"             
                @change="SelectSearch({id:'team',value:$event.target.value})">
              <option ></option>
              <option v-for="r in teamlist" :key="r.val" :value="r.val">{{r.val}}</option>
             </select>
            </div>
            <div class="row"  style="margin-bottom: 5px;"> 
              <label class="col-xs-3 control-label esma_form_label">所管区分</label>
              <select 
                 class="select-box"
                :value = "selvalues[Searchmap('jurisdiction_classification')]"
                :disabled = "selectdisable['jurisdiction_classification']" 
                :readonly = "selectreadonly['jurisdiction_classification']" 
                @change="SelectSearch({id:'jurisdiction_classification',value:$event.target.value})">
                <option ></option>
                <option v-for="r in classificationlist" :key="r.val" :value="r.val">{{r.val}}</option>
              </select>
            </div>
            <div class="row"  style="margin-bottom: 5px;"> 
              <label class="col-xs-3 control-label esma_form_label">システム</label>
              <select 
                 class="select-box"
                :value = "selvalues[Searchmap('system')]"
                :disabled = "selectdisable['system']" 
                :readonly = "selectreadonly['system']" 
                @change="SelectSearch({id:'system',value:$event.target.value})">
                <option ></option>
                <option v-for="r in systemlist" :key="r.val" :value="r.val">{{r.val}}</option>
              </select>
            </div>
             <div class="row"  style="margin-bottom: 5px">
            <div v-if = "alretteamreport && alretoutside==false" style="float:left">
              <font color="red">
              ※チーム単位報告
              </font>
            </div>
            <div v-if = "alretdepartmentreport && alretoutside==false" style="float:left">
              <font color="red">
              ※棚卸は部署単位で報告願います。
              </font>
            </div>
            <div v-if = "alretoutside" style="float:left">
              <font color="red">
              ※報告がロックされています
              </font>
            </div>
            </div>
            </div>
            <div class="col-xs-1" style="">
            </div>
            <div v-show = "ViewMainInfomation == true">
            <div class="col-xs-6" style="">
                <field-box
                  v-for="f in formFields.col0b"  
                  v-bind:key="f.id" 
                  v-bind:data="f"  :read="readOnly2" :val="values[f.id]+'％'"></field-box>
                  <field-box
                  v-for="f in formFields.col0c"  
                  v-bind:key="f.id" 
                  v-bind:data="f"  :read="readOnly2" :val="values[f.id]"></field-box>
            </div>
            </div> 
          </div>
        </div>
      <div v-show = "ViewMainInfomation == true">
        <div class="col-xs-12">
          <div
            style="float: right; font-size: 10px; text-align: right; color: red"
          >
            ＊入力必須項目
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12" >
            <div class="report_field col-xs-12">
              1.証書一覧
            </div>
          </div>
        </div>
          <div class="row" style="margin-top:15px;margin-bottom:20px;;margin-right:20px">
          <div class="row" style="">
            <div class="col-xs-6" style="">
                <field-box
                  v-for="f in formFields.col1"  
                  v-bind:key="f.id"
                  v-bind:data="f"  :read="readOnly2" :val="values[f.id]"
                  @on_update="updatecertcheck" 
                  ></field-box>
                <field-box
                  v-for="f in formFields.col1a"  
                  v-bind:key="f.id"
                  v-bind:data="f"  :read="readOnly2 || certeditable == false" :val="values[f.id]"></field-box>
            </div>
            <div class="col-xs-6" style="">
                <field-box
                  v-for="f in formFields.col1b"  
                  v-bind:key="f.id"   
                  v-bind:data="f"  :read="readOnly2" :val="values[f.id]"></field-box>
                <field-box
                  v-for="f in formFields.col1c"  
                  v-bind:key="f.id"   
                  v-bind:data="f"  
                  :read="readOnlycol1c" 
                  :val="values[f.id]"></field-box>
                <field-box
                  v-for="f in formFields.col1d"  
                  v-bind:key="f.id"   
                  v-bind:data="f"  :read="readOnly2" :val="values[f.id]"></field-box>
                <field-box
                  v-for="f in formFields.col1e"  
                  v-bind:key="f.id"   
                  v-bind:data="f"  
                  :read="readOnlycol1e" 
                  :val="values[f.id]"></field-box>
                <field-box
                  v-for="f in formFields.col1f"  
                  v-bind:key="f.id"   
                  v-bind:data="f"  :read="readOnly2" :val="values[f.id]"></field-box>                  
            </div>
            <div v-if = "alretunusedlicense == true" class="row" style="float:right">
              <font color="red">
              ※未使用ライセンスが0でない場合、ライセンスの未使用理由の記載が必要です。
              </font>
            </div>
            <div v-if = "alretexpiredlicense == true" class="row" style="float:right">
              <font color="red">
              ※期限切れライセンスが0でない場合、期限切れライセンス対応の入力が必要です。
              </font>
            </div>
            <div v-if = "alretremarkexpiredlicense == true" class="row" style="float:right">
              <font color="red">
              ※証書一覧備考の入力が必要です。
              </font>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12" >
            <div class="report_field">
              　2．機器・ソフトウェア紐付明細
            </div>
          </div>           
        </div>
          <div class="row" style="margin-top:15px;margin-bottom:20px;;margin-right:20px">
          <div class="row" style="">

            <div class="col-xs-6" style="">
              <field-box  
                v-for="f in formFields.col2"  
                v-bind:key="f.id" 
                v-bind:data="f"
                :read="readOnly2"
                @on_update="updatedevicecheck"                    
                :val="values[f.id]">
                </field-box>
                <field-box  
                v-for="f in formFields.col2a"  
                v-bind:key="f.id" 
                v-bind:data="f"
                :read="readOnly2 || dev_editable == false"                   
                :val="values[f.id]">
                </field-box>
            </div>
            <div class="col-xs-6" style="">
              <field-box  
                v-for="f in formFields.col2b"  
                v-bind:key="f.id" 
                v-bind:data="f"
                @on_update="numbersUpdated"                     
                :read="readOnly2"
                :val="values[f.id]"
                ></field-box>
            <div class="row" style="margin-left:74%;margin-bottom:5px">
              ① + ② + ③ + ④ = {{totallicense}}
            </div>
                <field-box  
                v-for="f in formFields.col2c1"  
                v-bind:key="f.id" 
                v-bind:data="f"
                @on_update="numbersUpdated"                     
                :read="readOnly2 || ($store.state[stateCurrentRow]['number_of_unattached'] == 0 && $store.state[stateCurrentRow]['lack_of_license'] == 0)"
                :val="values[f.id]"
                ></field-box>
                <field-box  
                v-for="f in formFields.col2c2"  
                v-bind:key="f.id" 
                v-bind:data="f"
                @on_update="numbersUpdated"                     
                :read="readOnly2 || ($store.state[stateCurrentRow]['number_of_unattached'] == 0 && $store.state[stateCurrentRow]['lost_license_certificate'] == 0)"
                :val="values[f.id]"
                ></field-box>
                <field-box  
                v-for="f in formFields.col2c3"  
                v-bind:key="f.id" 
                v-bind:data="f"
                @on_update="numbersUpdated"                     
                :read="readOnly2 || ($store.state[stateCurrentRow]['number_of_unattached'] == 0 && $store.state[stateCurrentRow]['no_evidence_of_license_receipt'] == 0)"
                :val="values[f.id]"
                ></field-box>
                <field-box  
                v-for="f in formFields.col2c4"  
                v-bind:key="f.id" 
                v-bind:data="f"
                @on_update="numbersUpdated"                     
                :read="readOnly2 || ($store.state[stateCurrentRow]['number_of_unattached'] == 0 && $store.state[stateCurrentRow]['other'] == 0)"
                :val="values[f.id]"
                ></field-box>
                <field-box  
                v-for="f in formFields.col2d"  
                v-bind:key="f.id" 
                v-bind:data="f"
                @on_update="numbersUpdated"                     
                :read="readOnly2"
                :val="values[f.id]"
                ></field-box>
            <div v-if = "alrettotallicense == true" class="row" style="float:right">
              <font color="red">
              ※①～④の合計数が未紐付数と一致しません。
              </font>
            </div>
            <div v-if = "alretother == true" class="row" style="float:right">
              <font color="red">
              ※④が0でない場合、[備考]欄での理由の記載が必要です。
              </font>
            </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12" >
            <div class="report_field">
              　3．その他
            </div>
          </div>           
        </div>
          <div class="row" style="margin-top:15px;margin-bottom:20px;;margin-right:20px">
          <div class="row" style="">

            <div class="col-xs-6" style="">
              <field-box  
                v-for="f in formFields.col3"  
                v-bind:key="f.id" 
                v-bind:data="f"
                :read="readOnly2" 
                :val="values[f.id]"></field-box>
            </div>
            <div class="col-xs-6" style="">
              <field-box  
                v-for="f in formFields.col3b"  
                v-bind:key="f.id" 
                v-bind:data="f"  :read="readOnly2" :val="values[f.id]"></field-box>
            </div>
          </div>
        </div>
        <div v-if="adminview == true">
        <div class="row">
          <div class="col-xs-12" >
            <div class="report_field">
              　4．管理者記載
            </div>
          </div>           
        </div>
          <div class="row" style="margin-top:15px;margin-bottom:20px;;margin-right:20px">
          <div class="row" style="">
            <div class="col-xs-6" style="">
              <field-box  
                v-for="f in formFields.col4"
                v-bind:key="f.id" 
                v-bind:data="f"
                :read="readOnly2 && readOnly3"
                :val="values[f.id]"></field-box>
                <button
                v-if="ViewEditbtn"
                class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-left: 5px;margin-right:5px;background: #FF7C80;;background: #337ab7;" 
                @click="adminremarkeditbtn"
                >編集</button>
                <button
                v-if="ViewEadminremarkditSetbtn"
                class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-left: 5px;margin-right:5px;background: #FF7C80;;background: #337ab7;" 
                @click="adminremarksetbtn"
                >入力完了</button>
                <button 
                v-if="ViewEadminremarkditSetbtn" 
                :disabled="false"
                class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-left: 5px;margin-right:5px;background: #A6A6A6;" 
                @click="adminremarkeditcancelbtn"
                >ｷｬﾝｾﾙ</button>
            </div>
            <!-- <div class="form1  col-xs-6" style="margin-left:15px;">
              <field-box  
                v-for="f in formFields.col3b"  
                v-bind:key="f.id" 
                v-bind:data="f"  :read="readOnly2" :val="values[f.id]"></field-box>
            </div> -->
          </div>
        </div>
        </div>
        <div v-if="ShowRejectBlock">
        <div class="row">
          <div class="col-xs-12" >
            <div class="report_field">
              　差戻
            </div>
          </div>           
        </div>
          <div class="row" style="margin-top:15px;margin-bottom:20px;;margin-right:20px">
          <div class="row" style="">
            <div class="col-xs-6" style="">
              <div v-if= "ShowRejectPerson">
              <field-box 
                v-for="f in formFields.col4a"
                v-bind:key="f.id" 
                v-bind:data="f"
                :read="true"
                :val="values[f.id]"></field-box>
                </div>
            </div>
            <div class="col-xs-6" style="">
              <div v-if= "ShowRejectReason">
              <field-box  
                v-for="f in formFields.col4b"
                v-bind:key="f.id" 
                v-bind:data="f" 
                :read="readOnly4"
                :val="values[f.id]"></field-box>
              </div>
                <div v-if = "ViewRejectEditbtn">
                <div class="row" style="text-align:end;margin-bottom:10px">
                  <font color="red">
                  ※差戻理由を入力し、入力完了をクリックしてください。(任意)
                  </font>
                </div>
                <button
                class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-left: 5px;margin-right:5px;background: #FF7C80;;background: #337ab7;" 
                @click="processApprovalCancel"
                >入力完了</button>
                <button 
                :disabled="false"
                class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-left: 5px;margin-right:5px;background: #A6A6A6;" 
                @click="rejectcancelbtn"
                >ｷｬﾝｾﾙ</button>
              </div>
            </div>
            </div>
        </div>
        </div>
              <!-- <div class=" col-6 " style="">
                <inventory-summary-box
                  :b1="counterB1"
                  :b2="counterB2"
                  :b3="counterB3"
                  :counter_b3_error_message="counterB3ErrorMessage"
                  :b4="counterB4"
                  style="width: 400px;    float: left;margin: 30px 0px 0px 10px;"/>
              </div> -->
      </div>
        <div class="row">
          <div class="col-xs-12" style="">
            <div class="row" style="margin-top:15px;margin-bottom:30px;margin-right:10px">
              <button class="btn btn-primary" style="min-width:100px;float: left;margin-left: -10px;" @click="backToList" >＜　戻る</button>
              <button
                v-if="ViewEditbtn"
                class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-left: 5px;margin-right:5px;background: #FF7C80;;background: #337ab7;" 
                @click="editbtn"
                >編集</button>
                <button 
                v-if="ViewEditCancelbtn" 
                :disabled="false"
                class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-left: 5px;margin-right:5px;background: #A6A6A6;" 
                @click="editcancelbtn"
                >ｷｬﾝｾﾙ</button>
               <button
               :disabled="checkUserPermission(true,permissionMode.DELETE) == false"
               v-if="pageEditable==true" class="btn btn-primary" style="min-width:100px;float:right;margin-left: 5px;margin-right:5px;background: #FF7C80;border-color:#FF7C80;" @click="onDelete">削除</button>
                <button
                  v-if="ViewApproval"
                  @click="ApprovalStage1()"
                  class="btn btn-primary process_approval_approve_btn"
                  style="min-width:100px;float: right;margin-left: 5px;background: #92D050;border-color:#92D050;"
                >承認</button>
                <button
                  v-if="ViewApprovalHistory"
                  @click="onConfirmInfomation()"
                  class="btn btn-primary process_approval_approve_btn"
                  style="min-width:100px;float: right;margin-left: 5px;background: #FF7C80;;background: #337ab7;"
                >申請ルート</button>
                <button
                v-if="ViewRejectbtn"
                class="btn btn-danger" style="min-width:100px;float: right;margin-left: 5px;margin-right:5px;background: #FF7C80;border-color:#FF7C80" 
                @click="rejecteditbtn">{{reject_label}}</button>
              <button
              v-if="ViewConfirmbtn" 
              class="btn btn-primary" style="min-width:100px;float: right;margin-left: 5px;margin-right:5px;background: #92D050;border-color:#92D050;" 
              @click="onConfirmExecuteProcessConfirmation" >申請</button>
              <button
              v-if="ViewSavebtn" 
              class="btn btn-primary" style="min-width:100px;float: right;margin-left: 5px;margin-right:5px;background: #337ab7;background: #337ab7;" 
              @click="onLocalSaveInventory" >{{savewords}}</button>
              <button
                v-if="ViewModeChangebtn"
                class="btn btn-primary" style="min-width:200px;width: 7%;float: right;margin-left: 5px;margin-right:5px;background: #FF7C80;border-color:#FF7C80;" 
                @click="reportmodebtn"
                >{{reportmodewords}}</button>
             <button
             v-if="viewExportFilebtn"
             class="btn btn-primary" style="min-width:100px;float: right;margin-left: 5px;margin-right:5px;background: #b83261;background: #337ab7;" @click="initExportFile" >出力</button>
            </div>
          </div>
        </div>
      </div>
      <confirmation-modal tag="confirmInventorySave" @done="onInventorySaveCondirmed" />
      <confirmation-modal tag="confirmInventorySaveEnd" />
      <confirmation-modal tag="confirmInventorySaveReject" />
      <confirmation-modal tag="confirmInventoryExport" @done="onInventoryExportCondirmed" />
      <confirmation-modal tag="deleteinventoryreportModal" @done="onConfirmDelete" />
      <confirmation-modal tag="reportmodeinventoryreportModal" @done="onConfirmReportModeChange" />
      <confirmation-modal tag="reportmodeinventoryreportModalReject" />
      <confirmation-modal tag="reportmodeinventoryreportEndModal" @done="onConfirmReportModeChangeEnd" />
      <confirmation-modal tag="confirminventoryonRejectEmbedded" @done="onReject" />
      <confirmation-modal tag="confirminventoryonRejectEmbeddednotification" @done="backToList"/>
      <confirmation-modal tag="stage1ConfirmatioInventory" @done="ApprovalStage2" />
      <confirmation-modal tag="ConfirmatioInvventorybackToList" @done="backToList" />
      <application-confirmation-modal-inventory tag="inventoryApplicationConfimationModal" @done="onCloseConfimation"/>
      <file-download-modal tag="runInventoryExportreportDownloadModal" @close="onCloseExportFile"/>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { fields, filed_types } from '@/rules/fields_inventory_report';　
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:inventory_report');
import fieldBoxes from '@/components/form-field';
import acl from '@/rules/acl_rules';
import applicationConfirmationModalInventory from "@/components/modals/application-confirmation-modal-inventory";
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import inventorySummaryBox from "@/components/inventory_summary_box";
import fileDownloadModal from '@/components/modals/file-download-modal';
import constants from "@/rules/constants";
import { bus } from '@/libs/bus';
import async from "async";

var timeout_control = {};
var queue_bus = []

export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'field-box': fieldBoxes,
    "inventory-summary-box":inventorySummaryBox,
    "application-confirmation-modal-inventory": applicationConfirmationModalInventory,
    'file-download-modal':fileDownloadModal
  },
  data() {
    return {
      api_name:"inventory_report",
      page_acl: acl.inventory_report,
      page_mode:"",
      inventory_sub_search :{},
      pri_sub_search :{},
      last_search:{},
      read_only2:true,
      read_only3:true,
      read_only4:true,
      counter_b1:"-",
      counter_b2:"-",
      counter_b3:"-",
      counter_b4:"-",
      update_Date:"",
      create_Date:"",
      status_value:"",
      new_or_resubmit_value :"",
      created_by_value:"",     
      total_license:"",
      cert_editable:false,
      dev_editable:false,
      alret_total_license:false,
      alret_other:false,
      alret_unused_license:false,
      alret_expired_license:false,
      alret_remark_expired_license:false,
      alret_outside:false,
      alret_team_report:false,
      alret_department_report:false,
      admin_editable:false,
      reporting_period_list:[],
      allow_to_submit:false,
      // group_0_error:false,
      saved_seq_id :-1,
       //search
      use_key:"inventory",
      select_list:{
        reporting_period:[],
        company:[],
        department:[],
        team:[],
        jurisdiction_classification:[],
        system:[],
        },
      select_disable:{
        reporting_period:false,
        company:false,
        department:false,
        team:false,
        jurisdiction_classification:false,
        system:false,
        },
      select_readonly:{
        reporting_period:false,
        company:false,
        department:false,
        team:false,
        jurisdiction_classification:false,
        system:false,
        },
      select_mode:"",
      search_map:false,
      reverse_map:false,
      back_jurisdiction_classification:"",
      //search End
      team_mode:false,
    };
  },
  computed: {
    reject_label(){
      if((this.$store.state[this.stateCurrentRow].approval_status == "申請中") && (this.pagemode == "loaded") && (this.$store.state[this.stateCurrentRow].created_by == Vue.localStorage.get("userID"))){
        return "取戻"
      }else{
        return "差戻"
      }
    },
    reportmodewords(){
      if(this.teammode){
        return "部署単位の報告に変更";
      }else{
        return "チーム単位の報告に変更";
      }
    },
    savewords(){
      if(this.$store.state[this.stateCurrentRow]["approval_status"]=="報告済"){
        return "上書保存";
      }else{
        return "下書保存";
      }
    },
 //search
    teammode:{
      get(){
        return this.team_mode;
      },
      set(v){
        this.team_mode = v;
      }
    },
    selvalues(){
      return this.inventory_sub_search;
    },
    selectdisable(){
      return this.select_disable;
    },
    selectreadonly(){
      return this.select_readonly;
    },
    companylist:{
      get(){
        return this.select_list.company;
      },
      set(v){
        this.select_list.company = v;
      }
    },
    selectmode:{
      get(){
        return this.select_mode;
      },
      set(v){
        this.select_mode = v;
        this.onselectmode(v);
      }
    },
    departmentlist:{
      get(){
        return this.select_list.department;
      },
      set(v){
        this.select_list.department = v;
      }
    },
    teamlist:{
      get(){
        return this.select_list.team;
      },
      set(v){
        this.select_list.team = v;
      }
    },
    classificationlist:{
      get(){
        return this.select_list.jurisdiction_classification;
      },
      set(v){
        this.select_list.jurisdiction_classification = v;
      }
    },
    systemlist:{
      get(){
        return this.select_list.system;
      },
      set(v){
        this.select_list.system = v;
      }
    },
    reportingPeriodList:{
      get(){
        return this.select_list.reporting_period;
      },
      set(v){
        this.select_list.reporting_period = v;
      }
    },
    selectedTab:{
      get(){
        return this.selected_tab;
      },
      set(v){
        this.selected_tab = v;
      }
    },
  //search End
    certeditable:{
      get(){
        return this.cert_editable;
      },
      set(v){
        this.cert_editable = v;
      }
    },
    deveditable:{
      get(){
        return this.dev_editable;
      },
      set(v){
        this.dev_editable = v;
      }
    },
    admineditable:{
      get(){
        return this.admin_editable;
      },
      set(v){
        this.admin_editable = v;
      }
    },
    totallicense:{
      get(){
        return this.total_license;
      },
      set(v){

        if(0<=v){
          this.total_license = v;          
        }else{
          this.total_license = "";
        }
      }
    },
    alrettotallicense:{
      get(){
        return this.alret_total_license;
      },
      set(v){
        this.alret_total_license = v;
      }
    },
    alretunusedlicense:{
      get(){
        return this.alret_unused_license;
      },
      set(v){
        this.alret_unused_license = v;
      }
    },
    alretexpiredlicense:{
      get(){
        return this.alret_expired_license;
      },
      set(v){
        this.alret_expired_license = v;
      }
    },
    alretremarkexpiredlicense:{
      get(){
        return this.alret_remark_expired_license;
      },
      set(v){
        this.alret_remark_expired_license = v;
      }
    },
    alretother:{
      get(){
        return this.alret_other;
      },
      set(v){
        this.alret_other = v;
      }
    },
    alretoutside:{
      get(){
        return this.alret_outside;
      },
      set(v){
        this.alret_outside = v;
      }
    },
    alretteamreport:{
      get(){
        return this.alret_team_report && (this.inventory_sub_search.jurisdiction_classification == "EUC・その他" || this.inventory_sub_search.jurisdiction_classification == "");
      },
      set(v){
        this.alret_team_report = v;
      }
    },
    alretdepartmentreport:{
      get(){
        return this.alret_department_report && (this.inventory_sub_search.jurisdiction_classification == "EUC・その他" || this.inventory_sub_search.jurisdiction_classification == "");
      },
      set(v){
        this.alret_department_report = v;
      }
    },
    adminview(){
      return (Vue.localStorage.get("userRole")== constants.PERMISSION.SYSTEM_ADMINISTRATOR 
      || Vue.localStorage.get("userRole") == constants.PERMISSION.MAINTENANCE_STAFF);
    },
    Editable(){
      return this.EditableUser && this.admineditable == true;
    },
    EditableUser(){
      return (Vue.localStorage.get("userRole")== constants.PERMISSION.SYSTEM_ADMINISTRATOR 
      || Vue.localStorage.get("userRole") == constants.PERMISSION.MAINTENANCE_STAFF)
      && Vue.localStorage.get("userCompany") == "ライセンス管理窓口";
    },
    readOnly2:{
      get(){
        return this.read_only2;
      },
      set(v){
        this.read_only2 = v;
      }
    },
    readOnly3:{
      get(){
        return this.read_only3;
      },
      set(v){
        this.read_only3 = v;
      }
    },
    readOnly4:{
      get(){
        return this.read_only4;
      },
      set(v){
        this.read_only4 = v;
      }
    },
    readOnlycol1c: function(){

        if (typeof this.$store.state[this.stateCurrentRow]['unused_license'] === 'undefined'){
          return this.read_only2;
        }
        var flag1 = (this.$store.state[this.stateCurrentRow]['unused_license'] == 0);
        var flag2 = true;
      if (typeof this.$store.state[this.stateCurrentRow]['reason_not_using'] !== 'undefined'){
          if(this.$store.state[this.stateCurrentRow]['reason_not_using'] != null){
              var flag2 = (this.$store.state[this.stateCurrentRow]['reason_not_using'] == '');
          }
        }
        return this.read_only2 || (flag1 && flag2);      
    },
    readOnlycol1e: function(){

        if (typeof this.$store.state[this.stateCurrentRow]['expired_license'] === 'undefined'){
          return this.read_only2;
        }
        var flag1 = (this.$store.state[this.stateCurrentRow]['expired_license'] == 0);
        var flag2 = true;
      if (typeof this.$store.state[this.stateCurrentRow]['expired_license_support'] !== 'undefined'){
          if(this.$store.state[this.stateCurrentRow]['expired_license_support'] != null){
              var flag2 = (this.$store.state[this.stateCurrentRow]['expired_license_support'] == '') ||
                          (this.$store.state[this.stateCurrentRow]['expired_license_support'] == '　') ;
          }
        }
        return this.read_only2 || (flag1 && flag2);      
    },
    pagemode:{
      get(){
        return this.page_mode;
      },
      set(v){
        this.page_mode = v;
        this.onchangemode();
      }
    },
    statusFieldStyle(){
      if(this.$store.state["current_field_style"] && this.$store.state["current_field_style"]["approval_status"]){
        return this.$store.state["current_field_style"]["approval_status"];
      }else{
        return ""
      }
    },
    viewExportFilebtn(){
      return (this.pagemode == "loaded")
    },
    pageEditable(){
      return (this.Editable == true) && (this.pagemode == "loaded") ;
    },
    ViewEditbtn(){
      //TODO:下書き中の処理
      return (this.pagemode == "loaded") && ((this.Editable == true) 
      || (this.$store.state[this.stateCurrentRow].approval_status == "差戻") || (this.$store.state[this.stateCurrentRow].approval_status == "下書中"))  ;
    },
    ViewApproval(){
      return ((this.pagemode == "loaded") && (this.$store.state[this.stateCurrentRow].approval_status == "申請中"))
      && (this.$store.state[this.stateCurrentRow].next_approver == Vue.localStorage.get("userID"));
    },
    ViewApprovalHistory(){
      return ((this.pagemode == "loaded") && (this.$store.state[this.stateCurrentRow].approval_status == "申請中"))
      ||((this.pagemode == "loaded") && (this.$store.state[this.stateCurrentRow].approval_status == "報告済"));
    },
    ViewRejectbtn(){
      return ((this.pagemode == "loaded") && (((this.Editable == true) )&& (this.$store.state[this.stateCurrentRow].approval_status != "差戻")&& (this.$store.state[this.stateCurrentRow].approval_status != "下書中"))
      ||((this.$store.state[this.stateCurrentRow].approval_status == "申請中") && (this.pagemode == "loaded") && (this.$store.state[this.stateCurrentRow].next_approver == Vue.localStorage.get("userID")))
      ||((this.$store.state[this.stateCurrentRow].approval_status == "申請中") && (this.pagemode == "loaded") && (this.$store.state[this.stateCurrentRow].created_by == Vue.localStorage.get("userID")))
      );
    },
    ViewEditCancelbtn(){
      return (this.pagemode == "edit") ;
    },
    ViewEadminremarkditSetbtn(){
      return (this.pagemode == "adminremarkedit") ;
    },
    ViewRejectEditbtn(){
      return (this.pagemode == "rejectedit") ;
    },
    ShowRejectReason(){
      return ((this.$store.state[this.stateCurrentRow].retraction_reason != "") 
      && (typeof this.$store.state[this.stateCurrentRow].retraction_reason != "undefined")
      && (this.$store.state[this.stateCurrentRow].retraction_reason != null))
      || (this.pagemode == "rejectedit");
    },
    ShowRejectPerson(){
      return ((this.$store.state[this.stateCurrentRow].retraction_person_label != "") 
      && (typeof this.$store.state[this.stateCurrentRow].retraction_person_label != "undefined")
      && (this.$store.state[this.stateCurrentRow].retraction_person_label != null));
    },
    ShowRejectBlock(){
      return this.ShowRejectReason || this.ShowRejectPerson;
    },
    ViewTopInfomation(){
      return (this.pagemode != "search" && this.pagemode != "outside" &&  this.pagemode != "new") ;
    },
    ViewMainInfomation(){
      return (this.pagemode != "search" && this.pagemode != "outside") || true ;
    },
    // group0Error:{
    //   get(){
    //     return this.group_0_error;
    //   },
    //   set(v){
    //     this.group_0_error = v;
    //   }
    // },
    ViewSavebtn(){
      return (this.read_only2 == false || this.page_mode == "edit")
    },
    ViewModeChangebtn(){
      return (this.read_only2 == false && this.Editable == true && this.page_mode != "edit")
    },
    ViewConfirmbtn(){
      return this.read_only2 == true && this.page_mode == "loaded" && (this.$store.state[this.stateCurrentRow].approval_status == "下書中") ;
    },
    allowToSubmit:{
      get(){
        return this.allow_to_submit;
      },
      set(v){
        this.allow_to_submit = v;
      }
    },
    // reportingPeriodList:{
    //   get(){
    //     return this.reporting_period_list;
    //   },
    //   set(v){
    //     this.reporting_period_list = v;
    //   }
    // },
    counterB3ErrorMessage:{
      get(){
        return this.counter_b3_error_message;
      },
      set(v){
        this.counter_b3_error_message = v;
      }
    },
    counterB1:{
      get(){
        return ""+this.counter_b1;
      },
      set(v){
        this.counter_b1 = v;
      }
    },
    counterB2:{
      get(){
        return ""+this.counter_b2;
      },
      set(v){
        this.counter_b2 = v;
      }
    },
    counterB3:{
      get(){
        return ""+this.counter_b3;
      },
      set(v){
        this.counter_b3 = v;
      }
    },
    counterB4:{
      get(){
        return ""+this.counter_b4;
      },
      set(v){
        this.counter_b4 = v;
      }
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    formFields() {
      return {
        col0:[
          utils.extend(fields.reporting_period, {emit_input:true}),
          utils.extend(fields.company, {emit_input:true}),
          utils.extend(fields.department_in_charge, {emit_input:true}),
          utils.extend(fields.jurisdiction_classification, {
            emit_input:true,
            on_set_value: (data) => {
              this.singleTimeout("upd_license_jurisdiction_system_it", setTimeout(() => {
                this.queuedBusEmit("upd_license_jurisdiction_system_it", {
                  val: data == "IT所管システム",
                });
              }, 500));
              setTimeout(() => {
                this.queuedBusEmit("upd_license_jurisdiction_system", {
                  val: data == "EUC・その他",
                });
              }, 100);
            },
          }),
          utils.extend(fields.reporting_system, {
            emit_input:true,            
            disabled: false,
            required: true,
            field_style: " width: 100%;display: block;",
            listen_for: [
              {
                name: "upd_license_jurisdiction_system_it",
                mode: "disable_and_clean_if_value",
                disable_if_value: true,
              },
            ],

          }),
        ],
        col0a:[
          utils.extend(fields.team_in_charge, {emit_input:true}),
        ],
        col0b:[
         utils.extend(fields.linkage_ratio, {}),
         utils.extend(fields.last_linkage_ratio, {}),
        ],
        col0c:[
         utils.extend(fields.number_of_registered_devices, {}),
         utils.extend(fields.number_of_registered_licenses, {}),
         utils.extend(fields.number_of_software_packages_used, {}),
         utils.extend(fields.number_of_installed_software_to_be_linked, {}),
         utils.extend(fields.number_of_installation_software_licenses_attached, {}),
        ],
        col1:[
         utils.extend(fields.certificate_list_check, {emit_input:true}),
        ],
        col1a:[
         utils.extend(fields.new_license_registration, {}),
         utils.extend(fields.change_license_information, {}),
         utils.extend(fields.disposal_of_license, {}),
        ],
        col1b:[
         utils.extend(fields.unused_license, {}),
        ],
        col1c:[    
         utils.extend(fields.reason_not_using, {}),
        ],
        col1d:[
         utils.extend(fields.expired_license, {}),
        ],
        col1e:[
         utils.extend(fields.expired_license_support, {}),
        ],
        col1f:[
         utils.extend(fields.certificate_remarks, {}),
        ],
        col2:[
         utils.extend(fields.ledger_check, {emit_input:true}),
        ],
        col2a:[
         utils.extend(fields.new_registration_of_equipment, {}),
         utils.extend(fields.change_device_information, {}),
         utils.extend(fields.disposal_of_device_information, {}),
        ],
        col2b:[
         utils.extend(fields.number_of_unattached, {}),
        ],
        col2c1:[
         utils.extend(fields.lack_of_license, {}),
        ],
        col2c2:[
         utils.extend(fields.lost_license_certificate, {}),
        ],
        col2c3:[
         utils.extend(fields.no_evidence_of_license_receipt, {}),
        ],
        col2c4:[
         utils.extend(fields.other, {}),
        ],
        col2d:[
         utils.extend(fields.remarks, {}),
        ],
        col3:[
         utils.extend(fields.contact_person, {label: "担当者（ﾌﾙﾈｰﾑ）",}),
        ],
        col3b:[
         utils.extend(fields.extension_number, {}),   
        ],
        col4:[
         utils.extend(fields.admin_remark, {}),              
        ],
        col4a:[
         utils.extend(fields.retraction_person_label, {}),              
        ],
        col4b:[
         utils.extend(fields.retraction_reason, {}),              
        ],
        col5:[
          utils.extend(fields.created_date, {}),  
          utils.extend(fields.last_update_date, {}),  
          utils.extend(fields.approval_status, {}),  
          utils.extend(fields.new_or_resubmit, {}),  
          utils.extend(fields.created_by_label, {}),  
        ],

      }
    },
    inventsearchkeys(){
      return ["reporting_period",
        "company",
        "department_in_charge",
        "team_in_charge",
        "jurisdiction_classification",
        "reporting_system"]
    },  
    searchkeys(){
      return [
        "reporting_period",
        "company",
        "department",
        "team",       
        "jurisdiction_classification",
        "system"]
    },
  },
  methods: {
 //search
    searchclear(){
      if(this.EditableUser == true){
        this.selectmode = "";
        this.inventory_sub_search[this.Searchmap("company")] = "";
      }else{
        this.selectmode = "department";   
      }

    },
    SelectSearch(p){
      this.inventory_sub_search[this.Searchmap(p.id)] = p.value;
      //initialization seq_id
      this.localSeqId = "new";
      if(p.value == ""){
        this.selectmode = this.get_empty_searchkey(p.id);
      }else{
        this.selectmode = p.id;
      }
    },
    teammodechange(p){
      this.teammode = p;
      this.refreshteammode();
      //チェックボックス0変更処理
      this.selvalues[this.Searchmap('team')] = "";
      this.onselectchange();
    },
    onselectchange(mode=""){
      this.variousjudgment_step1(this.inventory_sub_search,mode);
    },
     get_empty_searchkey(k){
      var map = {
        reporting_period:"reporting_period",
        company:"",
        department:"company",
        jurisdiction_classification:"department",
        team:"department",
        system:"jurisdiction_classification",
      };
      return map[k];
    },
   onselectmode(v,mode=""){
      switch (v){
        case "company":
            this.refreshteammode(mode);
            var target = {
              clear:["department","jurisdiction_classification","team","system"],
              open:["department"],
              disable:["jurisdiction_classification","team","system"],
              load_id:"department",
              api:"/master_belongs/list_department_use_subsearch",
              api_map:"belong",
              api_key:""
            };
            this.selectmodeproc(target,mode);
          break;
        case "department":
            this.refreshteammode(mode);
            var target = {
              clear:["jurisdiction_classification","team","system"],
              open:["jurisdiction_classification","team"],
              disable:["system"],
              load_id:"team",
              api:"/master_belongs/list_team_use_subsearch",
              api_map:"belong",
              api_key:""
              };
            this.selectmodeproc(target,mode);
          break;
        case "jurisdiction_classification":
          this.refreshteammode(mode);
          if(this.inventory_sub_search[this.Searchmap("jurisdiction_classification")] == "EUC・その他"){
            var target = {
              clear:["system"],
              open:["team"],
              disable:["system"],
              load_id:"team",
              api:"/master_belongs/list_team_use_subsearch",
              api_map:"belong",
              api_key:""
            };
            this.selectmodeproc(target,mode);
          }else{
            var target = {
              clear:["system","team"],
              open:["system"],
              disable:["team"],
              load_id:"system",
              api:"/master_system/list_system_name_use_subsearch",
              api_map:"system",
              api_key:""
            };
            this.selectmodeproc(target,mode);
          }
          break;
        case "system":
          this.refreshteammode(mode);
          this.onselectchange(mode); 
          break;
        case "team":
            var target = {
              clear:["system"],
              open:[],
              disable:[],              
              load_id:"system",
              api:"/master_system/list_system_name_use_subsearch",
              api_map:"system",
              api_key:""
            };
            this.selectmodeproc(target,mode);
          break;  
        case "reporting_period":
          this.refreshteammode(mode);         
          this.onselectchange(mode); 
          break;          
        default:
            this.refreshteammode(mode);
            var target = {
              clear:["department","jurisdiction_classification","team","system"],
              open:["company"],
              disable:["department","jurisdiction_classification","team","system"],
              load_id:"",
              api:"",
              api_map:"",
              api_key:""
            };
            this.selectmodeproc(target,mode);
          break;
      }
    },
   selectmodeproc(target,mode){
      var api_subsearch = {};
      var temp = ""
      for(var i in this.searchkeys){

        if(target.clear.includes(this.searchkeys[i])){
          if(mode!="setonly"){
          this.inventory_sub_search[this.Searchmap(this.searchkeys[i])] = "";
          this.select_list[this.searchkeys[i]] = "";
          }
        }

        if(target.disable.includes(this.searchkeys[i])){
          this.selectdisable[this.searchkeys[i]] = true;
        }
        if(target.open.includes(this.searchkeys[i])){
          this.selectdisable[this.searchkeys[i]] = false;
        }
      
        if(target.api_map != ""){
          temp = this.Searchmap(this.searchkeys[i],target.api_map);
          if(temp != ""){
            api_subsearch[temp] = this.inventory_sub_search[this.Searchmap(this.searchkeys[i])];
          }
        }

      }
      if(this.selectdisable["jurisdiction_classification"] == false){
          this.select_list["jurisdiction_classification"] = [{val:"EUC・その他"},{val:"IT所管システム"}];
      }


      if(target.load_id != "" && target.api != ""){
        //api_keyが空ならばリストは空に
        var keyflag = false;
        if(target.api_key != ""){
          if(this.inventory_sub_search[this.Searchmap(target.api_key)] == ""){
            keyflag = true;
          }
        }
        if(keyflag != true){
          this.$ajax.post_cached_queued(target.api, {sub_search:api_subsearch}, (err, data) => {
            if (err) {
              this.$notify({
                title: "データが読込めませんでした。",
                text: err,
                type: "error",
                duration: 10000,
              });
              return;
            }
                this.select_list[target.load_id] = data;
                this.onselectchange(mode);
          });
        }else{
          this.select_list[target.load_id] = [];
          this.onselectchange(mode);
        }
      }else{
        this.onselectchange(mode);        
      }
    },
    
    Searchmap(v,mode = this.use_key){
      if(this.search_map == false){
        this.search_map =
          {common:{
            reporting_period:"reporting_period",
            company:"company",
            jurisdiction_classification:"jurisdiction_classification",
            department:"department",
            team:"team",
            system:"system",
          },
            inventory:{
            reporting_period:"reporting_period",
            company:"company",
            jurisdiction_classification:"jurisdiction_classification",
            department:"department_in_charge",
            team:"team_in_charge",
            system:"reporting_system",
          },
          device:{
            company:"company",
            jurisdiction_classification:"equipment_in_charge_classification",
            department:"equipment_in_charge_department",
            team:"equipment_in_charge_team",
            system:"equipment_in_charge_system_it",
          },
          cert:{
            company:"company",
            jurisdiction_classification:"jurisdiction_classification",
            department:"licensed_department",
            team:"license_jurisdiction_team",
            system:"license_jurisdiction_system",
          },
          belong:{
            company:"company",
            department:"department",
            team:"team",
          },
          system:{
            company:"company",
            department:"equipment_in_charge_department",
            team:"system_jurisdiction_team",
            system:"system_name",
          },
        }
      
        this.reverse_map = {};
        for(var k in this.search_map){
          for(var k2 in this.search_map[k]){
            this.reverse_map[this.search_map[k][k2]] = k2;
          }
        }
      }
      var temp = this.reverse_map[v];
      return this.search_map[mode][temp] || "";
    },
    //search End
    SetSubSearch(){

      var map = this.searchkeys;
      for(var k in map){
        if(this.EditableUser == true || map[k] != "department"){
          if(map[k] == "company"){
            if(this.EditableUser == true){
              this.inventory_sub_search[this.Searchmap(map[k])] = "";
            }
          }else if(map[k] == "reporting_period"){
            this.inventory_sub_search[this.Searchmap(map[k])] = "";
          }else{
            this.inventory_sub_search[this.Searchmap(map[k])] = "";
            this.select_list[map[k]] = [];
            this.select_disable[map[k]] = true;
          }
          
        }
      }

      //窓口で無ければ会社と部署固定
      if(this.EditableUser == false){
        if(typeof this.pri_sub_search[this.Searchmap("company")] == "undefined"){
          this.pri_sub_search[this.Searchmap("company")] = this.inventory_sub_search[this.Searchmap("company")]
        }
        if(typeof this.pri_sub_search[this.Searchmap("department")] == "undefined"){
          this.pri_sub_search[this.Searchmap("department")] = this.inventory_sub_search[this.Searchmap("department")]
        }
      }


      //pri_sub_searchから以降
      var flag = false;
      for(var k in map){
        if(map[k] != "company" || this.EditableUser == true){
          flag = false;
          if(typeof this.pri_sub_search[this.Searchmap(map[k])] != "undefined"){
            for(var l in this.select_list[map[k]]){
              if(this.select_list[map[k]][l].val == this.pri_sub_search[this.Searchmap(map[k])]){
                flag = true;
                break;
              }
            }
            if(flag==false){
              this.select_list[map[k]] = [{val:this.pri_sub_search[this.Searchmap(map[k])]}]
            }
            this.inventory_sub_search[this.Searchmap(map[k])] = this.pri_sub_search[this.Searchmap(map[k])]
            this.onselectmode(map[k],"setonly");
          }
        }
      }
    },
    setState2PriSubSearch(){
      var map = this.searchkeys;
      this.pri_sub_search = {};
      for(var key in map){
        if(this.$store.state[this.stateCurrentRow][this.Searchmap(map[key])]!="" && typeof this.$store.state[this.stateCurrentRow][this.Searchmap(map[key])]!="undefined"){
          this.pri_sub_search[this.Searchmap(map[key])] = this.$store.state[this.stateCurrentRow][this.Searchmap(map[key])];
        }
      } 
    },
    updatecertcheck(){
      this.certeditable = this.$store.state[this.stateCurrentEditing]["certificate_list_check"]=="不一致";
      var v = this.certeditable;
      if(v==false && this.$store.state[this.stateCurrentEditing]["certificate_list_check"]!=""){
            this.$store.state[this.stateCurrentRow] ["new_license_registration"] = "無";
            this.$store.state[this.stateCurrentRow] ["change_license_information"] = "無";
            this.$store.state[this.stateCurrentRow] ["disposal_of_license"] = "無";
            this.$store.state[this.stateCurrentEditing] ["new_license_registration"] = "無";
            this.$store.state[this.stateCurrentEditing] ["change_license_information"] = "無";
            this.$store.state[this.stateCurrentEditing] ["disposal_of_license"] = "無";
        }else if(v==true){
            this.$store.state[this.stateCurrentRow] ["new_license_registration"] = "";
            this.$store.state[this.stateCurrentRow] ["change_license_information"] = "";
            this.$store.state[this.stateCurrentRow] ["disposal_of_license"] = "";
            this.$store.state[this.stateCurrentEditing] ["new_license_registration"] = "";
            this.$store.state[this.stateCurrentEditing] ["change_license_information"] = "";
            this.$store.state[this.stateCurrentEditing] ["disposal_of_license"] = "";
        }
    },
    updatedevicecheck(){
      this.deveditable = this.$store.state[this.stateCurrentEditing]["ledger_check"]=="不一致";
      var v = this.deveditable;
      if(v==false && this.$store.state[this.stateCurrentEditing]["ledger_check"]!=""){
          this.$store.state[this.stateCurrentRow] ["new_registration_of_equipment"] = "無";
          this.$store.state[this.stateCurrentRow] ["change_device_information"] = "無";
          this.$store.state[this.stateCurrentRow] ["disposal_of_device_information"] = "無";
          this.$store.state[this.stateCurrentEditing] ["new_registration_of_equipment"] = "無";
          this.$store.state[this.stateCurrentEditing] ["change_device_information"] = "無";
          this.$store.state[this.stateCurrentEditing] ["disposal_of_device_information"] = "無";        
        }else if(v==true){
          this.$store.state[this.stateCurrentRow] ["new_registration_of_equipment"] = "";
          this.$store.state[this.stateCurrentRow] ["change_device_information"] = "";
          this.$store.state[this.stateCurrentRow] ["disposal_of_device_information"] = "";
          this.$store.state[this.stateCurrentEditing] ["new_registration_of_equipment"] = "";
          this.$store.state[this.stateCurrentEditing] ["change_device_information"] = "";
          this.$store.state[this.stateCurrentEditing] ["disposal_of_device_information"] = "";   
        }
    },
    updateeditable(){
      this.certeditable = this.$store.state[this.stateCurrentEditing]["certificate_list_check"]=="不一致";
      this.deveditable = this.$store.state[this.stateCurrentEditing]["ledger_check"]=="不一致";
    },
    updateviewdata(){
      this.update_Date = utils.format_date_time(this.$store.state[this.stateCurrentRow]["last_update_date"])
      this.create_Date = utils.format_date(this.$store.state[this.stateCurrentRow]["created_date"]);
      this.status_value = this.$store.state[this.stateCurrentRow]["approval_status"] || "";
      this.new_or_resubmit_value = this.$store.state[this.stateCurrentRow]["new_or_resubmit"] || "";
      this.created_by_value = this.$store.state[this.stateCurrentRow]["created_by_label"] || "";
    },
    clearviewdata(){
      this.update_Date = "";
      this.create_Date = "";
      this.status_value = "";
      this.new_or_resubmit_value = "";
      this.created_by_value = "";
    },
    alretoff(){
          this.alrettotallicense =false;
          this.alretother = false;
          this.alretunusedlicense =false;
          this.alretexpiredlicense = false;
          this.alretoutside = false;
          this.alretremarkexpiredlicense = false
    },
    adminremarkeditbtn(){
      this.pagemode = "adminremarkedit";
    },
    rejecteditbtn(){
      //申請者差戻
      if(this.$store.state[this.stateCurrentRow].created_by == Vue.localStorage.get("userID")){
        this.processApprovalCancel();
      }else{
        this.pagemode = "rejectedit";
      }
    },
    adminremarkeditcancelbtn(){
      this.commonValidateFieldsClear(this, () => {});     
      this.readOnly4 = true;
      this.readOnly3 = true;
      this.readOnly2 = true;
      this.inventory_sub_search = this.last_search;
      this.pagemode = "load";
    },
    rejectcancelbtn(){
      this.commonValidateFieldsClear(this, () => {});         
      this.readOnly4 = true;
      this.readOnly3 = true;
      this.readOnly2 = true;
      this.inventory_sub_search = this.last_search;
      this.pagemode = "load";
    },
    editbtn(){
      this.pagemode = "edit";
    },
    editcancelbtn(){
      this.commonValidateFieldsClear(this, () => {});
      this.readOnly4 = true;
      this.readOnly3 = true;
      this.readOnly2 = true;
      this.inventory_sub_search = this.last_search;
      this.pagemode = "load";
    },
    getStatisticalData(){
        this.$ajax.post("/" + this.api_name + "/statistical_output/",{sub_search:this.inventory_sub_search},(err, result) => {
            if (err) {
                this.$notify({
                  title: "統計データの読込に失敗しました。",
                  text: err,
                  type: "error",
                  duration: 10000,
                });
              }else{
                var tempstore = _.clone(this.$store.state[this.stateCurrentRow]);
                for(var key in result){
                  this.$store.state[this.stateCurrentEditing][key] = result[key];
                  tempstore[key] = result[key];
                  if(key == "jurisdiction_system" ){
                    this.inventory_sub_search[key] = result[key]; 
                  }
                }
                //team自動挿入
                // if(typeof result["team_in_charge"] != "undefined" && result["team_in_charge"] != ""){
                //   this.selvalues[this.Searchmap('team')] = result["team_in_charge"];
                //   this.onselectmode("team","setonly");
                // }
                // }
                if(this.page_mode=="new"){
                  this.$store.state[this.stateCurrentEditing]["lack_of_license"]=0;
                  this.$store.state[this.stateCurrentEditing]["lost_license_certificate"]=0;
                  this.$store.state[this.stateCurrentEditing]["no_evidence_of_license_receipt"]=0; 
                  this.$store.state[this.stateCurrentEditing]["other"]=0;
                  tempstore["lack_of_license"]=0;
                  tempstore["lost_license_certificate"]=0;
                  tempstore["no_evidence_of_license_receipt"]=0; 
                  tempstore["other"]=0;
                  tempstore["certificate_list_check"] = "";
                  tempstore["ledger_check"] = "";
                  this.$store.state[this.stateCurrentEditing]["certificate_list_check"]=""; 
                  this.$store.state[this.stateCurrentEditing]["ledger_check"]="";
                }
              }
              this.$store.state[this.stateCurrentRow] = tempstore;                
                

        });
    },
    onchangemode(){
      switch (this.page_mode){
        case "search":
          this.readOnly4 = true;
          this.readOnly3 = true;
          this.readOnly2 = true;
          this.refreshfield();
          break;          
        case "load":
          this.readOnly4 = true;
          this.readOnly3 = true;
          this.readOnly2 = true;
          this.refreshfield();          
          this.inventory_admin_edit();
          break;
        case "load2":
          this.readOnly4 = true;
          this.readOnly3 = true;
          this.readOnly2 = true;
          this.loadFormData();
          break;
        case "loaded":
          break;
        case "not_found":
          this.readOnly4 = true;
          this.readOnly3 = true;
          this.readOnly2 = true;
          this.inventory_period_inquiry()
          break;
        case "new":
          this.onNewCreate();
          break;
        case "edit":
          this.alretoff();
          this.onEdit();          
          break;
        case "adminremarkedit":

          this.onAdminRemarkEdit();          
          break;
        case "rejectedit":
          this.onRejectEdit();          
          break;
        case "outside":
          this.alretoutside = true;
          break;
        default:
          this.refreshfield();
      }
    },
    inventory_period_inquiry(){
      this.$ajax.post("/" + this.api_name + "/inventory_admin_edit/",{reporting_period:this.inventory_sub_search["reporting_period"]},(err, result) => {
          if (err) {
              this.$notify({
                title: "棚卸編集可能データの読込に失敗しました。",
                text: err,
                type: "error",
                duration: 10000,
              });
            }else{
              if(result.editable=="許可"){
                this.pagemode = "new";
                this.admineditable = true;
              }else{
                this.pagemode = "outside";
                this.admineditable = false;
              }

            }
        });
        // this.$ajax.post("/" + this.api_name + "/inventory_period_inquiry/",{reporting_period:this.sub_search["reporting_period"]},(err, result) => {
        //   if (err) {
        //       this.$notify({
        //         title: "棚卸期間データの読込に失敗しました。",
        //         text: err,
        //         type: "error",
        //         duration: 10000,
        //       });
        //     }else{
        //       if(result.qty>0){
        //         this.pagemode = "new";
        //       }else{
        //         this.pagemode = "outside";
        //       }

        //     }
        // });
    },
    inventory_admin_edit(){
      this.$ajax.post("/" + this.api_name + "/inventory_admin_edit/",{reporting_period:this.inventory_sub_search["reporting_period"]},(err, result) => {
          if (err) {
              this.$notify({
                title: "棚卸編集可能データの読込に失敗しました。",
                text: err,
                type: "error",
                duration: 10000,
              });
            }else{
              if(result.editable=="許可"){
                this.admineditable = true;
              }else{
                this.admineditable = false;
              }

            }
            this.pagemode = "load2";
        });
    },
    onNewCreate(){
      this.refreshfield();
      this.readOnly2 = false;
      this.getStatisticalData();
      this.updateeditable();
      //team・system特殊
      if(this.inventory_sub_search[this.Searchmap("jurisdiction_classification")] == "EUC・その他"){
        this.inventory_sub_search[this.Searchmap("system")] = "";
      }else if(this.inventory_sub_search[this.Searchmap("jurisdiction_classification")] == "IT所管システム"){
        this.inventory_sub_search[this.Searchmap("team")] = "";
      }
 
    },
    onEdit(){
      this.readOnly2 = false;
      for(var key in this.$store.state[this.stateCurrentRow]){
         this.$store.state[this.stateCurrentEditing][key] = this.$store.state[this.stateCurrentRow][key];
      }
      if(this.$store.state[this.stateCurrentRow].approval_status == "差戻"){
        this.getStatisticalData();
      }
      this.updateeditable();
    },
    onAdminRemarkEdit(){
      this.readOnly3 = false;
    },
    onRejectEdit(){
      this.$store.state[this.stateCurrentRow].retraction_reason = "";
      this.readOnly4 = false;
    },
    reportmodebtn(){
      this.$ajax.post("/" + this.api_name + "/get_department_team_report_number/",{params:this.inventory_sub_search},(err, result) => {
        if (err) {
          this.$notify({
            title: "データの読込に失敗しました。",
            text: err,
            type: "error",
            duration: 10000,
          });
        }else{
          if(result.team_number > 0 || result.department_number > 0){
            //既に報告が作られてい場
               var tit = this.reportmodewords + "できません"
               var msg = "変更対象の報告が作成されています。<BR><font color='red'>実行には報告を削除する必要があります。</font>"; 
                    bus.$emit("reportmodeinventoryreportModalReject",{
                      title: tit,
                      message: msg,
                      yes_label: "戻る",
                      no_label: "",
                      yes_color:"info",
                      no_color:"",
                      model_height:"50"
                    });
          }else{
            var msg = this.reportmodewords + "しますが<BR>よろしいでしょうか?"; 
            bus.$emit("reportmodeinventoryreportModal",{
              title: "",
              message: msg,
              yes_label: "実行",
              no_label: "キャンセル",
              yes_color:"danger",
              no_color:"info",
              model_height:"50"
            });
          }
        }
    });

    },
    onConfirmReportModeChange(mode){
      if(mode != "yes"){
        return;
      }

      this.$ajax.post("/" + this.api_name + "/set_department_team_report_mode/",{params:this.inventory_sub_search},(err, result) => {
        if (err) {
          this.$notify({
            title: "データの書込に失敗しました。",
            text: err,
            type: "error",
            duration: 10000,
          });
        }else{

          var message = "報告単位が変更されました。";    
            bus.$emit("reportmodeinventoryreportEndModal",{
              message: message,
              title: "",
              yes_label: "",
              no_label: "OK",
              yes_color:"",
              no_color:"",
              model_height:"50",
              model_width: "390px"
              });
          }
       });
    },
    onConfirmReportModeChangeEnd(mode){
      this.teammodechange((this.teammode == false));
    },
    onDelete(){
      bus.$emit("deleteinventoryreportModal",{
        title: "削除",
        message: "棚卸報告の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color:"danger",
        no_color:"info",
        model_height:"50"
      });
    },
    onLoad(new_seq_id){
      this.localSeqId = new_seq_id;
      this.setState2PriSubSearch();
      this.SetSubSearch();
      this.setstateCurrentEditing();
      this.alretoff();
      this.numbersUpdated_process("",this.stateCurrentEditing);
      this.last_search = _.clone(this.inventory_sub_search);
      this.updateviewdata();
    },
    setstateCurrentEditing(){
      var map = ["certificate_list_check","new_license_registration","change_license_information"
      ,"disposal_of_license","unused_license","reason_not_using","expired_license"
      ,"expired_license_support","certificate_remarks","ledger_check","new_registration_of_equipment"
      ,"change_device_information","disposal_of_device_information","number_of_unattached"
      ,"lack_of_license","lost_license_certificate","no_evidence_of_license_receipt","other"
      ,"remarks","contact_person","extension_number","admin_remark","created_date","last_update_date"
      ,"approval_status","new_or_resubmit","created_by_label","retraction_person","retraction_reason"];
      for(var m in map){
        if(typeof this.$store.state[this.stateCurrentRow][map[m]] !="undefined"){
          this.$store.state[this.stateCurrentEditing][map[m]] = _.clone(this.$store.state[this.stateCurrentRow][map[m]]);
        }
      }      
    },
    refreshfield(){
      this.local_seq_id = Number.MAX_SAFE_INTEGER;
      var tempstore = _.clone(this.$store.state[this.stateCurrentRow]);
      tempstore = {
        seq_id : this.local_seq_id
      }
      //stateCurrentEditing初期化
      this.$store.state[this.stateCurrentEditing] = [];
        for(var key in this.formFields){
          for(var v in this.formFields[key]){
            if(key != "col0"){
              tempstore[this.formFields[key][v].id] = "";
              this.$store.state[this.stateCurrentEditing][[this.formFields[key][v].id]] = "";
            }else{
              if(typeof this.inventory_sub_search[this.formFields[key][v].id] != "undefined"){
                tempstore[this.formFields[key][v].id] = this.inventory_sub_search[this.formFields[key][v].id]

              }
            }
          }
      }
  
      for(var k in this.inventory_sub_search){
          tempstore[k] = this.inventory_sub_search[k];
          this.$store.state[this.stateCurrentEditing][k] = this.inventory_sub_search[k];
      }
      this.$store.state[this.stateCurrentRow] = tempstore;
      this.clearviewdata();
      this.numbersUpdated(false);
      this.alretoff();
    },
    //teammode初期化
    refreshteammode(mode=""){
      if(mode!="setonly"){
        this.alretteamreport = false;
        this.alretdepartmentreport = false;
      }
    },
    numbersUpdated(o){
      this.numbersUpdated_process(o,this.stateCurrentEditing);
    },
    numbersUpdated_process(o,SCE){
      this.totallicense = parseInt(this.$store.state[SCE]["lack_of_license"]||0) 
                + parseInt(this.$store.state[SCE]["lost_license_certificate"]||0) 
                + parseInt(this.$store.state[SCE]["no_evidence_of_license_receipt"]||0) 
                + parseInt(this.$store.state[SCE]["other"]||0)
    },    
    judesubseachmode(search){
      var flag = true;
      var map = this.inventsearchkeys;
      for(var key in map){
        if(!((map[key] == "reporting_system" && search["jurisdiction_classification"] == "EUC・その他")
        || (map[key] == "team_in_charge" && (search["jurisdiction_classification"] == "IT所管システム" || this.teammode == false)))){
          if(search[map[key]]=="" || typeof search[map[key]]=="undefined"){
            flag = false;
          }
        }
      }
      return flag;
    },
    variousjudgment_step1(search,mode=""){
      
      //teammode judgment
      var tflag = true;
      var map = this.inventsearchkeys;
      for(var key in map){
        if(map[key] == "reporting_period" || map[key] == "company" || map[key] == "department_in_charge"){
          if(search[map[key]]=="" || typeof search[map[key]]=="undefined"){
            tflag = false;
          }
        }
      }

      if(tflag){
          this.$ajax.post("/" + this.api_name + "/get_department_team_report_mode/",{params:this.inventory_sub_search},(err, result) => {
                if (err) {
                this.$notify({
                  title: "データの読込に失敗しました。",
                  text: err,
                  type: "error",
                  duration: 10000,
                });
              }else{
                if(result.team_unit_reporting > 0){
                  this.teammode = true; 
                  this.alretteamreport = true;
                }else{
                  this.teammode = false; 
                  this.alretdepartmentreport = true;
                  this.selvalues[this.Searchmap('team')] = "";
                }
                this.variousjudgment_step2(search,mode)
              }
            }
          );
      }else{
        this.teammode = false; 
        this.variousjudgment_step2(search,mode)        
      }

    },
    variousjudgment_step2(search,mode=""){
      if(mode=="setonly"){
        return;
      }
      if(this.judesubseachmode(search)== true){
        this.pagemode = "load";
      }else{
        this.pagemode = "search";        
      }
    },
    loadFormData(){
      mdebug("page_0071_inventory_report mounting");
        // link_from_device_embedded_software_to_certificate_software_number step3
        if(this.judesubseachmode(this.inventory_sub_search) == false){
          this.pagemode = "search"
          return;
        }
        var certificate_software_number = this.$route.params.certificate_software_number;
        this.$ajax.post("/" + this.api_name + "/get_by_search_data/",{params:this.inventory_sub_search,seq_id:this.localSeqId},(err, result) => {
            if (err) {
              if(err == "not_found"){
                this.pagemode = "not_found";
              }else{

                this.$notify({
                  title: "データの読込に失敗しました。",
                  text: err,
                  type: "error",
                  duration: 10000,
                });
              }
            }else{
            this.$store.state[this.stateCurrentRow] = result.data;
            this.pagemode = "loaded";
            this.onLoad(result.data.seq_id);
            }
          }
        );
    },
 
    ApprovalStage1(){
          bus.$emit("stage1ConfirmatioInventory",{
            title: "",
            message: "承認を行います。よろしいですか？",
            yes_label: "承認",
            no_label: "戻る",
            yes_color:"info",
            no_color:"default",
            model_height:"50"
          })
    },
    ApprovalStage2(mode){
      /**
       * 2 - When aprove, execute at the server
       * 3 - Then show the results message.
       */
      if(mode != "yes"){
        return;
      }
      var arr = [this.$store.state[this.stateCurrentRow].a_seq_id];
      var hash = 0;
      arr.forEach(e =>{
        hash = hash + ((e + 3) * 2) // Simple hash to avoid direct request
      })
      this.$ajax.post("/approval_history_inventory/approve", {arr,hash}, (err, response) => {
        console.log({response})
        if(err){
          var title = "データの承認に失敗しました。";
        this.$notify({
            title: title, 
            text:err,
            type: "error",
            duration: 10000
          });
        }else{
          this.back_jurisdiction_classification = this.inventory_sub_search.jurisdiction_classification;
          bus.$emit("ConfirmatioInvventorybackToList",{
            title: "承認が完了しました。", 
            message: "",
            yes_label: "",
            no_label: "戻る",
            yes_color:"info",
            no_color:"default",
            model_height:"50"
          })
        }
      });

    },
    //notadmin reject
    processApproval(approve_mode) {
      var changes = {
        seq_id: this.$store.state[this.stateCurrentRow].a_seq_id,
        update_time: moment(new Date()).format("YYYY/MM/DD HH:mm:ss"),
        retraction_reason:this.$store.state[this.stateCurrentEditing].retraction_reason,
        retraction_person:Vue.localStorage.get("userID") || ""
      };
      var created_by_flag = this.$store.state[this.stateCurrentRow].created_by == Vue.localStorage.get("userID");
      if(approve_mode == "cancel"){
        // this.commonSaveInfo(this,this.api_name, {from_edit_form: true },(err)=>{
        //   if(err){
        //     //commonSaveInfo already show the error, can ignore it
        //   }else{
            this.$ajax.post('/approval_history_inventory/prepare_to_approve/' + this.$store.state[this.stateCurrentRow].a_seq_id, {changes,approve_mode:approve_mode}, (err, result) => {
              if(err){
                this.$notify({
                  title: 'データの承認に失敗しました。',
                  text: err,
                  type: 'error',
                  duration: 10000
                });
              }else{
                this.back_jurisdiction_classification = this.inventory_sub_search.jurisdiction_classification;
                if(created_by_flag == true){
                  var c_title = "";
                  var message = "申請が取戻されました"; 
                }else{
                  var c_title = "申請が差戻されました"
                  var message = "自動でメール通知はされませんので、口頭または<br>メールで差戻したことを申請者へお伝えください。";    
                }
                bus.$emit("confirminventoryonRejectEmbeddednotification",{
                  message: message,
                  title: c_title,
                  yes_label: "",
                  no_label: "OK",
                  yes_color:"",
                  no_color:"",
                  model_height:"50",
                  model_width: "390px"
                });
              }
            });
        //   }
        // });
      }else{
      }
    },
    onReject(mode){
      if (mode == "yes") {
        if(this.$store.state[this.stateCurrentRow].approval_status == "報告済"){
         // this.provalCancelModeSet(false);
          var arr = [{
            a_seq_id:this.$store.state[this.stateCurrentRow].a_seq_id,
            seq_id:this.$store.state[this.stateCurrentRow].seq_id,
            retraction_reason:this.$store.state[this.stateCurrentEditing].retraction_reason,

            }];
          var hash = 0;
          arr.forEach(e =>{
            hash = hash + ((e.seq_id + 3) * 2) // Simple hash to avoid direct request
          })

          this.$ajax.post("/" + this.api_name + "/admin_reject/" , {arr,hash}, (err, response) => {
              if(err){
              this.$notify({
                  title: "差戻に失敗しました",
                  text:err,
                  type: "error",
                  duration: 10000
                });
              }else{
                  this.back_jurisdiction_classification = this.inventory_sub_search.jurisdiction_classification;
                  this.pagemode = "load";
                  var message = "自動でメール通知はされませんので、口頭または<br>メールで差戻したことを申請者へお伝えください。";    
                  bus.$emit("confirminventoryonRejectEmbeddednotification",{
                    message: message,
                    title: "申請が差戻されました",
                    yes_label: "",
                    no_label: "OK",
                    yes_color:"",
                    no_color:"",
                    model_height:"50",
                    model_width: "390px"
                    });
              }
          });

        }else{

          this.processApproval("cancel");
          // this.local_status = false;
        }
      }
    },
    onRejectEmbedded(){    
      var created_by_flag = this.$store.state[this.stateCurrentRow].created_by == Vue.localStorage.get("userID");
      if(created_by_flag == true){
        var c_title = "申請を取戻します。";
        var c_yes_label = "取戻"; 
      }else{
        var c_title = "申請を差戻します。"
        var c_yes_label = "差戻";    
      }
      
      bus.$emit("confirminventoryonRejectEmbedded", {
        message: "よろしいですか？",
        title: c_title,
        yes_label: c_yes_label,
        no_label: "戻る",
        yes_color: "primary",
        no_color: "",
        model_height: "50",
      });
    },

    processApprovalCancel() {
      console.log("processApprovalCancel");
      this.onRejectEmbedded();
      // this.ApprovalCancelModeSet(true);
    },
    // ApprovalCancelModeSet(aflag){
    //   var bflag = this.hideApprovalcancel;
    //   if (typeof this.fieldList["retraction_reason"] != "undefined"){
    //     if(aflag == true){
    //         this.fieldList["retraction_reason"].hide_all = bflag;
    //         this.fieldList["retraction_reason"].force_write = true;
    //         this.approvalcancelmode = true;
    //     }else{
    //         this.fieldList["retraction_reason"].hide_all = true;
    //         this.fieldList["retraction_reason"].force_write = false;
    //         this.approvalcancelmode = false;
    //     }
    //     if (typeof this.fieldList["retraction_reason"].ref_field != "undefined"){
    //     this.fieldList["retraction_reason"].ref_field.refresh_hide_force();
    //     }
    //   }
    // },
    setdefseach(){
      if(typeof this.$route.params.inventory_sub_search != "undefined"){
        var load_search = _.clone(this.$route.params.sub_search);
        for(var key in Object.keys(load_search)){
          this.pri_sub_search[this.Searchmap(load_search[key])] = load_search[key];           
        }
      }
    },

    onConfirmDelete(mode){
      if(mode == "yes"){
        var option = { 
            a_seq_id:this.$store.state[this.stateCurrentRow].a_seq_id,
            seq_id:this.$store.state[this.stateCurrentRow].seq_id
            }
          this.$ajax.post("/" + this.api_name + "/delete" , option, (err, response) => {
              if(err){
              this.$notify({
                  title: "削除に失敗しました",
                  text:err,
                  type: "error",
                  duration: 10000
                });
              }else{
                    bus.$emit("ConfirmatioInvventorybackToList",{
                    title : "",
                    message: "棚卸報告が削除されました",
                    yes_label: "",
                    no_label: "OK",
                    yes_color:"",
                    no_color:"",
                    model_height:"50",
                    model_width: "390px"
                    });
              }
          });
      }
    },
    initExportFile(){
      this.api_request_options = {sub_search:"inventory_sub_search",seq_id:this.$store.state[this.stateCurrentRow].seq_id};
      //FILE_EXPORT_PART2 : Step 2
      bus.$emit("runInventoryExportreportDownloadModal",{
        message: "ファイルを出力しています。",
        on_complete_message:"出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        api_request_options: this.api_request_options,
        sub_search:this.inventory_sub_search,
        url:"/inventory_report/export_form_data/"
      });
    },
    backToList(){
      // return this.$router.push({ path: '/inventory_management', params: {} });
      var device_back_to_list_name = window.sessionStorage.getItem("device_back_to_list_name")
      var back_search = _.clone(this.inventory_sub_search);

      if(this.back_jurisdiction_classification==""){
        if(typeof this.$route.params.force_return_jurisdiction_classification !="undefined"){
          back_search.jurisdiction_classification = this.$route.params.force_return_jurisdiction_classification;
        }
      }else{
        back_search.jurisdiction_classification = this.back_jurisdiction_classification;
      }
      if((device_back_to_list_name||"") != ""){
        return this.$router.push({ name: device_back_to_list_name, params:{sub_search:back_search}});
      }else{
        return this.$router.push({ name: 'page_0070_inventory_tabs_management', params:{sub_search:back_search}});
      }
    },
    adminremarksetbtn(){
      var changes = {
        seq_id: this.localSeqId ,
        admin_remark: this.$store.state[this.stateCurrentEditing]["admin_remark"],
      }
      this.$ajax.post("/" + this.api_name + "/set/" + this.localSeqId , {changes}, (err, response) => {
          if(err){
          this.$notify({
              title: "データの保存に失敗しました。",
              text:err,
              type: "error",
              duration: 10000
            });
          }else{
            
          }
          this.pagemode = "load"         
        });
    },
    onInventorySaveCondirmed(mode){
      if(mode == "yes"){
        
        if(this.$store.state[this.stateCurrentRow].new_or_resubmit != "新規" &&　this.$store.state[this.stateCurrentRow].new_or_resubmit != "再提出"){
          this.$store.state[this.stateCurrentEditing].new_or_resubmit = "新規";
        }
        
        //差戻関係の記述を削除
        if(this.$store.state[this.stateCurrentRow].approval_status == "差戻"){
          this.$store.state[this.stateCurrentEditing].retraction_person = "";
          this.$store.state[this.stateCurrentEditing].retraction_person_name = "";
          this.$store.state[this.stateCurrentEditing].retraction_reason = "";
        }

        if(this.$store.state[this.stateCurrentRow].approval_status == "報告済"){
          var message = "棚卸報告の上書き保存が完了しました。";
        }else{
          var message = "棚卸報告の下書き保存が完了しました。<BR><BR><font color='red'>※棚卸報告の編集が完了した場合は、<BR>下書き保存後、申請を行ってください。</font>";
          this.$store.state[this.stateCurrentEditing].approval_status = "下書中";
        }

        var map = this.searchkeys;
        for(var k in map){
          this.$store.state[this.stateCurrentRow][this.Searchmap(map[k])] = this.inventory_sub_search[this.Searchmap(map[k])];
          this.$store.state[this.stateCurrentEditing][this.Searchmap(map[k])] = this.inventory_sub_search[this.Searchmap(map[k])];
        }
        
        var certificate_software_number = this.$route.params.certificate_software_number;
        this.$ajax.post("/" + this.api_name + "/get_by_search_data/",{params:this.inventory_sub_search,seq_id:"new"},(err, result) => {
            if (err == "not_found" || this.localSeqId != "new") {
              this.commonSaveInfo(this,this.api_name, {},(err,data_result)=>{
                      if(err == null && data_result && data_result && data_result.seq_id > -1){
                        this.saved_seq_id = data_result.seq_id
                      }
                      bus.$emit("confirmInventorySaveEnd",{
                        message: message,
                        title: "",
                        yes_label: "",
                        no_label: "OK",
                        yes_color:"",
                        no_color:"",
                        model_height:"50"
                      });
                      this.pagemode = "load"
                    });

            }else{
              bus.$emit("confirmInventorySaveReject",{
                message: "<font color='red' size='2'>対象の棚卸報告は既に作成されています。</font>",
                title_style : "color: red",
                title: "※棚卸報告を作成できません※",
                yes_label: "",
                no_label: "戻る",
                yes_color:"",
                no_color:"",
                model_height:"50"
              });
              this.pagemode = "load"
            }

        });
      }
    },
    onInventoryExportCondirmed(mode){
     if(mode == "yes"){
        this.initExportFile();
      }else if(mode == "no"){
      }

    },
    onCloseConfimation(mode){
      if(mode == "yes"){
        var message = "棚卸報告を申請しました。<br>報告内容をExcelで出力しますか？";
        bus.$emit("confirmInventoryExport",{
          message: message,
          title: "",
          yes_label: "はい(Excel出力)",
          no_label: "戻る",
          yes_color:"primary",
          no_color:"",
          model_height:"50"
        });
        this.pagemode = "load"
      }else{
        
      }
    },
    onCloseExportFile(){},

    onLocalSaveInventory(){
      console.log("onLocalSave");

        this.commonValidateFields(this, {}, (error_found) => {
        if (error_found != false) {
          return;
        }
        this.alretunusedlicense = 
        ((this.$store.state[this.stateCurrentEditing]["unused_license"]||0) != 0) 
        && ((this.$store.state[this.stateCurrentEditing]["reason_not_using"]||"") == "");
        if(this.alretunusedlicense == true){
          return;
        }

        this.alretexpiredlicense = 
        ((this.$store.state[this.stateCurrentEditing]["expired_license"]||0) != 0) 
        && ((this.$store.state[this.stateCurrentEditing]["expired_license_support"] == "　") || (this.$store.state[this.stateCurrentEditing]["expired_license_support"]) == "");
        if(this.alretexpiredlicense == true){
          return;
        }

        this.alretremarkexpiredlicense = 
        (this.$store.state[this.stateCurrentEditing]["expired_license_support"] == "その他(備考に詳細を記入)") 
        && (this.$store.state[this.stateCurrentEditing]["certificate_remarks"] == "");
        if(this.alretremarkexpiredlicense == true){
          return;
        }
        this.alrettotallicense = this.total_license != (this.$store.state[this.stateCurrentRow]["number_of_unattached"]);
        if(this.alrettotallicense == true){
          return;
        }
        this.alretother = 
        ((this.$store.state[this.stateCurrentEditing]["other"]||0) != 0) 
        && ((this.$store.state[this.stateCurrentEditing]["remarks"]||"") == "");
        if(this.alretother == true){
          return;
        }
        if(this.$store.state[this.stateCurrentEditing]["certificate_list_check"]=="一致"){
            this.$store.state[this.stateCurrentRow] ["new_license_registration"] = "無";
            this.$store.state[this.stateCurrentRow] ["change_license_information"] = "無";
            this.$store.state[this.stateCurrentRow] ["disposal_of_license"] = "無";
            this.$store.state[this.stateCurrentEditing] ["new_license_registration"] = "無";
            this.$store.state[this.stateCurrentEditing] ["change_license_information"] = "無";
            this.$store.state[this.stateCurrentEditing] ["disposal_of_license"] = "無";
          }
        if(this.$store.state[this.stateCurrentEditing]["ledger_check"]=="一致"){
          this.$store.state[this.stateCurrentRow] ["new_registration_of_equipment"] = "無";
          this.$store.state[this.stateCurrentRow] ["change_device_information"] = "無";
          this.$store.state[this.stateCurrentRow] ["disposal_of_device_information"] = "無";
          this.$store.state[this.stateCurrentEditing] ["new_registration_of_equipment"] = "無";
          this.$store.state[this.stateCurrentEditing] ["change_device_information"] = "無";
          this.$store.state[this.stateCurrentEditing] ["disposal_of_device_information"] = "無";        
          }
        if(this.$store.state[this.stateCurrentRow]["approval_status"]!="報告済"){
          var message = "棚卸報告を下書き保存します。よろしいですか？";
        }else{
          var message = "棚卸報告を上書き保存します。よろしいですか？";
        }
        bus.$emit("confirmInventorySave",{
          message: message,
          title: "",
          yes_label: "はい",
          no_label: "戻る",
          yes_color:"primary",
          no_color:"",
          model_height:"50"
        });
      });
    },
    onConfirmExecuteProcessConfirmation() {
      bus.$emit("inventoryApplicationConfimationModal", {
        application_mode: "inventory",
        
        // approval_status:this.approvalStatus,
        seq_id: this.localSeqId,
        is_surplus: this.isSurplus
      });
    },

    onConfirmInfomation() {
      bus.$emit("inventoryApplicationConfimationModal", {
        application_mode: "inventory",
        ref_id: this.$store.state[this.stateCurrentRow].ref_id || false,
        modal_is_read_only: true,
        seq_id: this.localSeqId,
        approval_history_id: this.$store.state[this.stateCurrentRow].a_seq_id || false,
      });
    },

    loadReportingPeriodList(){
      this.$ajax.post("/" + this.api_name + "/get_reporting_period_list", {}, (err, data) => {
        data.forEach(d=>{
          this.reportingPeriodList.push(d.reporting_period)
        })
      });
    },
    onmouted(){
      this.commonLoadRecord({},(err,result)=>{
        if(err){
        }

        if(this.$route.params.seq_id != "new"){
          this.onLoad(this.$route.params.seq_id);
          this.inventory_admin_edit();
          this.variousjudgment_step1(this.inventory_sub_search,"setonly");
          this.pagemode = "loaded";


        }else{
          this.localSeqId = "new";
          this.pagemode = "search";
          this.setdefseach();
          this.SetSubSearch();
        }
     });

    }
  },
  mounted() {
    this.api_request_options = {sub_search:"inventory_sub_search",seq_id:this.$route.params.seq_id};
    this.readOnly4 = true;
    this.readOnly3 = true;
    this.readOnly2 = true;
    if(typeof this.$route.params.seq_id =="undefined"){
      this.$route.params.seq_id = "new";
    }
        
    this.$ajax.post("/master_inventory_reporting_period/list_reporting_period", {}, (err, data) => {
          if (err) {
            this.$notify({
              title: "報告期分が読み込めませんでした",
              text: err,
              type: "error",
              duration: 10000,
            });
          }
          this.reportingPeriodList = data;
        if(this.EditableUser == true){
            this.$ajax.post_cached_queued( "/master_company/list_company_name", {}, (err, _companies) => {
            if (err) {
              this.$notify({
                title: "所管会社のデータが読込めませんでした。",
                text: err,
                type: "error",
                duration: 10000,
              });
              return;
            }
                _companies.forEach(d=>{
                    d.value =d.val;
                  })
                this.companylist = _companies;
                if(this.EditableUser == false){
                  for(var k in this.companylist){
                    this.inventory_sub_search.company = this.companylist[k].val;
                    break;
                  }
                }
                this.selectmode = "";   
                this.onmouted();
          });
        }else{
            var usercompany = Vue.localStorage.get("selectedCompany") || "";
            var userdepartment = Vue.localStorage.get("userDepartment") || "";
            this.select_list["company"] = [{val:usercompany,value:usercompany}];
            this.select_list["department"] = [{val:userdepartment,value:userdepartment}];
            this.inventory_sub_search[this.Searchmap("company")] =  usercompany;
            this.inventory_sub_search[this.Searchmap("department")] =  userdepartment;
            this.selectmode = "department";   
            this.onmouted();
          }
        });
  },
  beforeMount() {
  },
  beforeDestroy() {
  },
};

</script>
<style scoped>

.report_field {
  width: 101%;
  height: 30px;
  background:#A6A6A6;
  text-align: start;
  color:#ffffff;
  line-height: 30px;
  margin-left: -20px;
}

.report_field_select{
float: left; 
line-height: 25px;
width: 230px;
}
.line1{
line-height: 25px;
width: 120px;
}
.textbox{
line-height: 25px;
}
.form1{
max-width: 550px;
margin-top: 30px;
margin-bottom: 30px;
}
.input:focus::-webkit-input-placeholder {
  color: transparent;
}
.select-box {
  border: 1px solid #CCC;
  margin-top: 2px;
  margin-left: 5px;
  width :73%;
  text-indent:5px;
}
.select-box[disabled]{
  background-color: #cccccc;
  padding: 0px 6px 0px 6px;
}
.esma_form_label {
  background-color: #b4d5f1 !important;
  margin: 2px 0px !important;
  padding: 4px !important;
  font-size: 11px !important;
  text-align: center !important;
}
.esma_form_group {
  padding: 0px !important;
  margin: 0px !important;
}

</style>


// WEBPACK FOOTER //
// page_0071_inventory_report.vue?ed5cfe18